// extracted by mini-css-extract-plugin
export var agreementActionLink = "PartnerLegalPage-module__agreementActionLink___TzorT";
export var agreementCard = "PartnerLegalPage-module__agreementCard___Ir4yU";
export var agreementContent = "PartnerLegalPage-module__agreementContent___ENPau";
export var agreementDescription = "PartnerLegalPage-module__agreementDescription___3xMDC";
export var agreementTitle = "PartnerLegalPage-module__agreementTitle___OHQGN";
export var checkbox = "PartnerLegalPage-module__checkbox___ZNhbL";
export var content = "PartnerLegalPage-module__content___D8dEc";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var enrollButton = "PartnerLegalPage-module__enrollButton___Jie8C";
export var enrollmentActions = "PartnerLegalPage-module__enrollmentActions___tTIvO";
export var errorMessage = "PartnerLegalPage-module__errorMessage___fQ2T+";
export var mainColumn = "PartnerLegalPage-module__mainColumn___SN4a5";
export var processingButton = "PartnerLegalPage-module__processingButton___wWTxs";
export var processingSpinner = "PartnerLegalPage-module__processingSpinner___qUFT4";
export var rejectedSettingsLink = "PartnerLegalPage-module__rejectedSettingsLink___BTOzm";
export var resendActions = "PartnerLegalPage-module__resendActions___QQwpY";
export var resendButton = "PartnerLegalPage-module__resendButton___gGRpO";
export var retryActions = "PartnerLegalPage-module__retryActions___nGNVo";
export var sectionTitle = "PartnerLegalPage-module__sectionTitle___EmE1f";
export var signedDate = "PartnerLegalPage-module__signedDate___zOqvm";
export var spin = "PartnerLegalPage-module__spin___aLP2r";
export var supportLink = "PartnerLegalPage-module__supportLink___KbyhE";
export var termsCheckboxContainer = "PartnerLegalPage-module__termsCheckboxContainer___YYY9V";
export var termsLabel = "PartnerLegalPage-module__termsLabel___Qf2U7";
export var unavailableLabel = "PartnerLegalPage-module__unavailableLabel___w3vus";
export var viewButton = "PartnerLegalPage-module__viewButton___OJdGJ";